import type { ISectionComponentProps } from '@components/ReportContent/types';

import ContactSectionContent from './ContactSectionContent';

const ContactSection = ({ sectionData }: ISectionComponentProps) => {
  if (!('data' in sectionData) || !('contact_person' in sectionData.data) || !('email' in sectionData.data)) {
    return <div>Error: Invalid data for Contact section.</div>;
  }
  return <ContactSectionContent contactData={sectionData.data} />;
};

export default ContactSection;
